export const LOADER_SET = 'loader/SET';

export const loaderSet = (data) => ({
  type: LOADER_SET,
  data,
});
